(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class SphRecommendationNavigation extends HTMLElement {
    #frame;
    #scroller;
    #arrows;
    #resizeObserver = new ResizeObserver(() => this.#queue());
    #mutationObserver = new MutationObserver(() => this.#queue());

    connectedCallback() {
      this.#frame = requestAnimationFrame(() => {
        this.#scroller = this.querySelector(':scope > slideshow-component > slideshow-container > slideshow-slides');
        this.#arrows = this.querySelector(':scope > slideshow-component > slideshow-container > slideshow-arrows');
        if (!this.#scroller || !this.#arrows) return;
        this.#scroller.addEventListener('scroll', this.#queue, { passive: true });
        this.#resizeObserver.observe(this.#scroller);
        for (const slide of this.#scroller.children) this.#resizeObserver.observe(slide);
        this.#mutationObserver.observe(this.#arrows, {
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled']
        });
        this.#update();
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.#frame);
      this.#resizeObserver.disconnect();
      this.#mutationObserver.disconnect();
      this.#scroller?.removeEventListener('scroll', this.#queue);
    }

    #queue = () => {
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(() => this.#update());
    };

    #update() {
      if (!this.isConnected || !this.#scroller || !this.#arrows) return;
      const maximum = this.#scroller.scrollWidth - this.#scroller.clientWidth;
      const position = Math.abs(this.#scroller.scrollLeft);
      const overflow = maximum > 1;
      this.dataset.overflow = String(overflow);
      const previous = this.#arrows.querySelector('[ref="previous"]');
      const next = this.#arrows.querySelector('[ref="next"]');
      const previousDisabled = !overflow || position <= 1;
      const nextDisabled = !overflow || position >= maximum - 1;
      if (previous && previous.disabled !== previousDisabled) previous.disabled = previousDisabled;
      if (next && next.disabled !== nextDisabled) next.disabled = nextDisabled;
    }
  }

  if (!customElements.get('sph-recommendation-navigation')) {
    customElements.define('sph-recommendation-navigation', SphRecommendationNavigation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sph-live-catalog"] && !Shopify.designMode) return;
  try {
    
  function sphSyncCatalogExpandButtons(root) {
    if (!root) return;
    var rows = Array.from(root.querySelectorAll('.sph-live-catalog__groups details.sph-live-catalog__details'));
    var everyOpen = rows.length > 0 && rows.every(function(row) { return row.open; });
    var everyClosed = rows.length > 0 && rows.every(function(row) { return !row.open; });
    root.querySelectorAll('[data-sph-catalog-toggle]').forEach(function(button) {
      var action = button.getAttribute('data-sph-catalog-toggle');
      var active = action === 'expand' ? everyOpen : everyClosed;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function sphInitCatalogUX(container) {
    if (!container) return;
    var roots = [];
    if (container.matches && container.matches('.sph-live-catalog--modern')) roots.push(container);
    if (container.querySelectorAll) {
      container.querySelectorAll('.sph-live-catalog--modern').forEach(function(root) { roots.push(root); });
    }
    roots.forEach(function(root) {
      var controls = root.querySelector('.sph-live-catalog__expand-tools');
      if (controls) controls.hidden = false;
      var back = root.querySelector('.sph-live-catalog__back-to-groups');
      if (back) back.hidden = false;
      sphSyncCatalogExpandButtons(root);
    });
    sphUpdateCatalogBackLinks();
  }

  function sphUpdateCatalogBackLinks() {
    document.querySelectorAll('.sph-live-catalog--modern').forEach(function(root) {
      var nav = root.querySelector('#catalog-productgroepen');
      var back = root.querySelector('.sph-live-catalog__back-to-groups');
      if (nav && back && !back.hidden) {
        var rectangle = nav.getBoundingClientRect();
        var catalog = root.getBoundingClientRect();
        back.classList.toggle('is-visible', rectangle.bottom < 0 && catalog.bottom > 120);
      }

      var controls = root.querySelector('.sph-live-catalog__expand-tools');
      var groups = root.querySelector('.sph-live-catalog__groups');
      if (controls && groups && !controls.hidden) {
        var stickyTop = parseFloat(window.getComputedStyle(controls).top) || 0;
        var listBottom = groups.getBoundingClientRect().bottom;
        controls.classList.toggle('is-after-groups', listBottom <= stickyTop + controls.offsetHeight + 6);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { sphInitCatalogUX(document); });
  } else {
    sphInitCatalogUX(document);
  }
  document.addEventListener('shopify:section:load', function(event) { sphInitCatalogUX(event.target); });
  var sphCatalogScrollScheduled = false;
  function sphScheduleCatalogScrollUpdate() {
    if (sphCatalogScrollScheduled) return;
    sphCatalogScrollScheduled = true;
    window.requestAnimationFrame(function() {
      sphCatalogScrollScheduled = false;
      sphUpdateCatalogBackLinks();
    });
  }
  window.addEventListener('scroll', sphScheduleCatalogScrollUpdate, {passive:true});
  window.addEventListener('resize', sphScheduleCatalogScrollUpdate);

  document.addEventListener('click', function(event) {
    var target = event.target;
    var button = target && target.closest ? target.closest('[data-sph-catalog-toggle]') : null;
    if (!button) return;
    var root = button.closest('.sph-live-catalog--modern');
    if (!root) return;
    var action = button.getAttribute('data-sph-catalog-toggle');
    if (action !== 'expand' && action !== 'collapse') return;
    var expand = action === 'expand';
    root.querySelectorAll('.sph-live-catalog__groups details.sph-live-catalog__details').forEach(function(detail) { detail.open = expand; });
    sphSyncCatalogExpandButtons(root);
  });

  document.addEventListener('toggle', function(event) {
    var detail = event.target;
    if (!detail || !detail.matches || !detail.matches('details.sph-live-catalog__details')) return;
    var root = detail.closest('.sph-live-catalog--modern');
    if (root) sphSyncCatalogExpandButtons(root);
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sph-october-offer"]) return;
  try {
    
  function expireSphOctoberOffer() {
    document.querySelectorAll('[data-sph-offer-end]').forEach((bar) => {
      const remaining = Date.parse(bar.dataset.sphOfferEnd) - Date.now();
      if (remaining <= 0) bar.remove();
      else window.setTimeout(() => bar.remove(), Math.min(remaining, 2147483647));
    });
  }

  expireSphOctoberOffer();
  window.addEventListener('pageshow', expireSphOctoberOffer);

  } catch(e) { console.error(e); }
})();
})();
